import React, { useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { Box } from '@mui/material';
import { loginService } from '../../services';
import { createCaptcha, deletCaptcha, showCaptcha, RECAPTCHA_SITE_KEY as SITE_KEY } from '../../helpers';
import { useTranslation } from 'react-i18next';
import platforms from '../../constants/users/platforms';
import PasswordForm from './PasswordCreator';
import '../../styles/sass/auth/passwordForm.scss';
import CustomAlert from '../../components/Alert';

export default function Verify () {
    const { t } = useTranslation();
    const history = useHistory();
    const query = new URLSearchParams(useLocation().search);
    const token = query.get('token');
    const idToken = Number(query.get('_'));
    // State
    // Alert states
    const [alert, setAlert] = useState({
        severity: '',
        title: '',
        description: '',
        className: ''
    });
    const [openAlert, setOpenAlert] = useState(false);

    // Password state
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    // recaptcha data
    let captchaToken = '';
    // reCaptcha scriptCaptcha state
    // eslint-disable-next-line no-unused-vars
    const [scriptCaptcha, setScriptCaptcha] = useState('');

    // Functions
    const validateLink = () => {
        const data = {
            idPlatform: platforms.backoffice,
            // TODO change email
            email: 'no-reply@backoffice.com',
            metadata: {
                token,
            },
            idToken
        };
        // setValidateUserId(10028);
        // setVerifying(false);
        loginService
            .validateForgot(data)
            .then(response => {
                setAlert((prevAlert) => ({
                    ...prevAlert,
                    severity: 'success',
                    title: t('recover.recover.success'),
                    description: t('recover.recover.description'),
                    className: 'clientsMC_Alert--success'
                }));
                setOpenAlert(true);
            })
            .catch((e) => {
                setAlert((prevAlert) => ({
                    ...prevAlert,
                    severity: 'error',
                    title: t('errors.generalTitle'),
                    description: t('errors.generalDescription'),
                    className: 'passwordForm_Alert--error'
                }));
                setOpenAlert(true);
                console.error(e);
            });
    };

    const changePassword = () => {
        setIsLoading(true);

        if (password !== confirmPassword) {
            setAlert((prevAlert) => ({
                ...prevAlert,
                severity: 'error',
                title: t('recover.changePassword.error'),
                className: 'passwordForm_Alert--error'
            }));
            setOpenAlert(true);
            setIsLoading(false);
            return false;
        }

        const data = {
            idPlatform: platforms.backoffice,
            captchaToken,
            idToken: idToken, // otp
            token,
            password: password
        };

        loginService
            .change(data)
            .then(response => {
                setAlert((prevAlert) => ({
                    ...prevAlert,
                    severity: 'success',
                    title: t('recover.recover.success'),
                    className: 'clientsMC_Alert--success'
                }));
                setOpenAlert(true);
                setTimeout(() => {
                    setIsLoading(false);
                    history.push('/auth/login');
                }, 3000);
            })
            .catch(e => {
                const error = e?.response?.data;
                if (error.code === 400 && error.extra.invalidations && error.extra.invalidations.includes('personal_data')) {
                    setAlert((prevAlert) => ({
                        severity: 'error',
                        title: t('errors.generalTitle'),
                        description: t('errors.invalidPassword'),
                        className: 'passwordForm_Alert--error'
                    }));
                    setOpenAlert(true);
                    console.error(e);
                    setIsLoading(false);
                    return;
                }
                setAlert((prevAlert) => ({
                    ...prevAlert,
                    severity: 'error',
                    title: t('errors.generalTitle'),
                    description: t('errors.generalDescription'),
                    className: 'passwordForm_Alert--error'
                }));
                setOpenAlert(true);
                console.error(e);
                setIsLoading(false);
            });
    };

    // reCAPTCHA Enterprise verification on a user interaction
    const onClick = (e) => {
        setIsLoading(true);
        return window.grecaptcha.enterprise.ready(function () {
            // execute devuelve el token
            window.grecaptcha.enterprise.execute(SITE_KEY, { action: 'RECOVER' })
                .then(token => {
                    captchaToken = token;
                    changePassword();
                })
                .catch(error => {
                    setAlert((prevAlert) => ({
                        ...prevAlert,
                        severity: 'error',
                        title: t('errors.generalTitle'),
                        description: t('errors.generalDescription'),
                        className: 'passwordForm_Alert--error'
                    }));
                    setOpenAlert(true);
                    setIsLoading(false);
                    console.error(error);
                });
        });
    };

    // useEffects
    useEffect(() => {
        validateLink();
        createCaptcha(setScriptCaptcha, SITE_KEY);
        showCaptcha();

        return () => {
            deletCaptcha();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Box>
            <CustomAlert
                openAlert={openAlert}
                setOpenAlert={setOpenAlert}
                alert={alert}
                setAlert={setAlert}
            />
            <PasswordForm
                password={password}
                confirmPassword={confirmPassword}
                setPassword={setPassword}
                setConfirmPassword={setConfirmPassword}
                onClick={onClick}
                isLoading={isLoading}
                type='recover'
                subtitle={t('recover.description')} />
        </Box>
    );
}
